import { MaterialReactTable } from "material-react-table";

import ReserveActions from "@/features/reserves/components/table/ReserveActions";
import ReserveTableColumns from "@/features/reserves/components/table/ReserveTableColumns";
import { ReserveBaseModel } from "@/features/reserves/types/reserveModels";
import { OverviewItemsModel } from "@/shared/components/baselineOverview/model/baselineOverviewModels";

export type ReserveTableProps = {
  reserves: ReserveBaseModel[];
  handleSaveCell: (
    original: ReserveBaseModel,
    name: string,
    value: number | string
  ) => void;
  refetchReserve: () => void;
  overviewItems: OverviewItemsModel[];
};

export default function ReserveTable({
  reserves,
  handleSaveCell,
  refetchReserve,
  overviewItems,
}: ReserveTableProps) {
  const columns = ReserveTableColumns({ handleSaveCell, overviewItems });
  return (
    <MaterialReactTable
      columns={columns}
      layoutMode="grid"
      data={reserves}
      enableTableFooter
      initialState={{
        density: "compact",
        columnPinning: {
          right: ["mrt-row-actions"],
        },
      }}
      positionToolbarAlertBanner="none"
      muiTableHeadCellProps={{
        sx: () => ({
          background: "var(--primary-color)",
          align: "center",
          color: "#fff",
          fontSize: "12px",
          overflowX: "hidden",
        }),
      }}
      enableClickToCopy
      muiTableBodyCellProps={{
        align: "right",
        sx: {
          border: "none",
          background: "#fff",
          "& .MuiButtonBase-root": {
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
          // Remove Material-UI button ripple effect completely
          "& .MuiTouchRipple-root": {
            display: "none",
          },
        },
      }}
      muiTableFooterCellProps={{
        sx: {
          background: "#fff",
        },
      }}
      muiBottomToolbarProps={{
        sx: {
          background: "#fff",
        },
      }}
      muiTableProps={{
        sx: {
          tableLayout: "fixed",
        },
      }}
      muiTableContainerProps={{
        sx: {
          maxHeight: 700,
          overflow: "auto",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "8px !important",
            backgroundColor: "#f5f5f5",
            height: "12px !important",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            backgroundColor: "#ccc",
            "&:hover": {
              backgroundColor: "#b3b3b3",
            },
            "&:active": {
              backgroundColor: "#808080",
            },
          },
        },
      }}
      editDisplayMode="cell"
      enableColumnResizing
      enableColumnActions={false}
      enableColumnFilters={false}
      enableTopToolbar={false}
      enablePagination
      enableSorting
      enableRowActions
      renderRowActions={({ row }) => (
        <ReserveActions reserveId={row.original.id} refetchReserve={refetchReserve} />
      )}
    />
  );
}
